import React from 'react';
import { marketingUrl } from 'helpers/constants';
import { CheckLabel } from 'components/shared';
import styles from './LoginCheckbox.module.scss';

interface LoginCheckboxProps {
  isChecked: boolean;
  onChange: (checked: boolean) => void;
}

export const LoginCheckbox = ({ isChecked, onChange }: LoginCheckboxProps) => {
  return (
    <CheckLabel checked={isChecked} className={styles.checkbox} type="Flat" onChange={onChange}>
      <span>
        I accept the{' '}
        <a href={`${marketingUrl}terms-of-service/`} rel="noopener noreferrer" target="_blank">
          Terms of Service
        </a>
        {' and '}
        <a href={`${marketingUrl}privacy/`} rel="noopener noreferrer" target="_blank">
          Privacy Policy
        </a>
      </span>
    </CheckLabel>
  );
};
